import * as React from 'react'
import type {SVGProps} from 'react'
const SvgStarHalf = (props: SVGProps<SVGSVGElement>) => (
    <svg width={14} height={14} viewBox="0 0 475.044 475.044" {...props}>
        <path
            fill="#4fccb1"
            fillRule="evenodd"
            d="M474.487 183.276c-1.711-5.236-6.852-8.52-15.41-9.851l-143.323-20.839L251.52 22.681q-5.999-11.705-13.989-11.704-8.28-.001-13.988 11.704l-64.241 129.905-143.324 20.839Q3.131 175.423.563 183.276q-2.565 7.853 6.567 16.989l103.924 101.068-24.553 142.749c-.95 6.286-.381 11.173 1.715 14.702q3.14 5.284 9.707 5.283c3.237 0 7.043-1.14 11.42-3.433l128.194-67.382 128.19 67.382c4.377 2.286 8.186 3.433 11.423 3.433 4.381 0 7.622-1.759 9.709-5.283 2.088-3.529 2.659-8.416 1.708-14.702l-24.551-142.749 103.63-101.068q9.427-9.136 6.841-16.989m-135.89 91.789-13.99 13.421 3.43 18.843 17.128 101.357-90.786-47.965-16.848-8.856V76.927l45.395 91.933 8.559 17.128 18.85 2.856 101.642 14.844z"
        />
    </svg>
)
export default SvgStarHalf
